module.exports = __webpack_public_path__ + "media/download.7a0cba9a.mp3";